import { PricingActionTypes } from './action-types';
import { reducePromotionsResponse } from 'pricing-pages-lib/reducers/Promotions';
import { reduceProductsResponse } from 'pricing-pages-lib/reducers/Products';
export const initialPricingState = {
  productData: null,
  promotions: null,
  currencyCode: null,
  requiredOnboarding: null,
  dtbId: null
};

const pricingReducer = (state = initialPricingState, action) => {
  switch (action.type) {
    case PricingActionTypes.UpdateProductsResponse:
      {
        const parsedProductResponse = reduceProductsResponse(action.productResponse);
        return Object.assign({}, state, {
          productData: parsedProductResponse
        });
      }

    case PricingActionTypes.UpdatePromotionsResponse:
      {
        const parsedPromotionsResponse = reducePromotionsResponse(action.promotionsResponse);
        return Object.assign({}, state, {
          promotions: parsedPromotionsResponse
        });
      }

    case PricingActionTypes.UpdateCurrencyCode:
      {
        return Object.assign({}, state, {
          currencyCode: action.currencyCode
        });
      }

    case PricingActionTypes.UpdateRequiredOnboarding:
      {
        return Object.assign({}, state, {
          requiredOnboarding: action.requiredOnboarding
        });
      }

    case PricingActionTypes.UpdateDtbId:
      {
        return Object.assign({}, state, {
          dtbId: action.dtbId
        });
      }

    default:
      return state;
  }
};

export default pricingReducer;